import PropTypes from 'prop-types';

import { MyChartLogin } from '@/design-system/molecules/MyChartLogin';
import { generateStyleModifiers } from '@/utils/generateStyleModifiers';

/**
 * AEM Integration wrapper for MyChartLogin component.
 * Maps AEM component properties to React component props.
 *
 * Supports both legacy iframe mode and new Epic widget mode.
 * When widgetUrl, apiKey, and widgetSdkUrl are provided, uses Epic widget.
 * Falls back to legacy widgetSrc iframe when Epic props are not available.
 */
const IntegrationMyChartLogin = (props) => {
    const modifiers = generateStyleModifiers(props.appliedCssClassNames);
    const theme = modifiers.theme;

    return <MyChartLogin {...props} theme={theme} />;
};

IntegrationMyChartLogin.propTypes = {
    /** Title displayed above the widget */
    title: PropTypes.string,
    /** @deprecated Legacy iframe widget URL */
    widgetSrc: PropTypes.string,
    /** MyChart base URL for Epic widget */
    widgetUrl: PropTypes.string,
    /** Epic Widget API key */
    apiKey: PropTypes.string,
    /** URL to Epic widget SDK script */
    widgetSdkUrl: PropTypes.string,
    /** Post-login redirect destination */
    postLoginUrl: PropTypes.string,
    /** Array of link buttons below widget */
    linkList: PropTypes.array,
    /** CSS class names from AEM for style modifiers */
    appliedCssClassNames: PropTypes.string,
};

export default IntegrationMyChartLogin;
